import { render } from "./addClientTrainingBlock.html?vue&type=template&id=788b6dee&scoped=true&ts=true&external"
import script from "./AddClientTrainingBlock.vue?vue&type=script&lang=ts"
export * from "./AddClientTrainingBlock.vue?vue&type=script&lang=ts"

import "./AddClientTrainingBlock.vue?vue&type=style&index=0&id=788b6dee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788b6dee"]])

export default __exports__